import { Skeleton, Typography } from "@mui/material";
import { t } from "i18next";
import NWONSection from "../../03-organisms/NWONSection/NWONSection";

import { useNWONTeamVideoStyles } from "./NWONTeamVideoStyles";

const NWONTeamVideo = (): JSX.Element => {
  const { classes } = useNWONTeamVideoStyles();

  return (
    <div className={classes.videoEmbedContainer}>
      <Skeleton
        variant="rectangular"
        animation="wave"
        className={classes.skeletonAndVideo}
      />

      <video
        className={classes.skeletonAndVideo}
        autoPlay={true}
        loop={true}
        muted={true}
        width="100%"
        playsInline={true}
      >
        <source src={`/media/videos/teamVideo.mp4`} type="video/mp4" />

        <source src={`/media/videos/teamVideo.mov`} type="video/mov" />
      </video>

      <NWONSection className={classes.headlineSection}>
        <Typography className={classes.h1} variant="h1">
          {t("pages:team.heroSection.title")}
        </Typography>
      </NWONSection>
    </div>
  );
};

export default NWONTeamVideo;
